export enum FilterLevels {
  CountryGroup = -1,
  World = 0,
  Region,
  Subregion,
  Country,
  Airport,
}
